// import { useEffect, useState } from 'react';
// import { Table, Tag, Space, Button, Input, Card, Row, Col, message, Modal } from 'antd'; 
// import { SearchOutlined, ReloadOutlined, DownloadOutlined, DeleteOutlined } from '@ant-design/icons';
// import http from '../../api'; 
// import { getAllBills, deleteBill } from '../../api';

// const BillList = () => {
//   const [billData, setBillData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searchText, setSearchText] = useState('');
//   const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
//   const [currentDeleteBillId, setCurrentDeleteBillId] = useState('');

//   // 获取账单列表
//   const fetchData = async (search = '') => {
//     console.log('===== 开始获取账单数据 =====');
//     console.log('搜索关键词：', search, '类型：', typeof search);
//     setLoading(true);
//     try {
//       const res = await getAllBills(search);
//       console.log('账单接口返回原始数据：', res);
      
//       if (res?.success && Array.isArray(res.data)) {
//         setBillData(res.data);
//         console.log('账单数据加载成功，共', res.data.length, '条：', res.data);
//       } else {
//         setBillData([]);
//         console.error('账单数据格式错误：success=', res?.success);
//         message.error('账单数据格式错误');
//       }
//     } catch (err) {
//       console.error('加载账单失败（完整错误信息）：', {
//         message: err.message,
//         response: err.response,
//         stack: err.stack
//       });
//       message.error('加载账单失败，请检查接口连接');
//       setBillData([]);
//     } finally {
//       setLoading(false);
//       console.log('===== 获取账单数据结束 =====');
//     }
//   };

//   // 初始化加载
//   useEffect(() => {
//     fetchData();
//   }, []);

//   // 搜索处理
//   const handleSearch = () => {
//     console.log('触发搜索，当前搜索文本：', searchText);
//     fetchData(searchText);
//   };

//   // 打开删除弹窗
//   const showDeleteModal = (billId) => {
//     console.log('===== 触发删除账单弹窗 =====');
//     console.log('待删除账单ID：', billId, '类型：', typeof billId);
    
//     if (!billId) {
//       console.error('账单ID为空！');
//       message.warning('账单ID不能为空，请刷新页面重试');
//       return;
//     }
//     if (isNaN(Number(billId))) {
//       console.error('账单ID格式错误，不是数字：', billId);
//       message.warning('账单ID必须为数字，请检查数据');
//       return;
//     }

//     setCurrentDeleteBillId(billId);
//     setIsDeleteModalVisible(true);
//   };

//   // 确认删除（核心修复版）
//   const handleDeleteConfirm = async () => {
//     // 强制处理billId，避免空值/类型问题
//     const finalBillId = String(currentDeleteBillId).trim();
//     if (!finalBillId) {
//       console.error('当前要删除的账单ID为空！');
//       message.error('删除失败：账单ID为空，请刷新页面重试');
//       setIsDeleteModalVisible(false);
//       return;
//     }

//     console.log('用户点击弹窗「确认删除」，开始调用删除接口');
//     console.log('当前要删除的账单ID：', finalBillId, '类型：', typeof finalBillId);
    
//     try {
//       setLoading(true);
//       // 调用封装的deleteBill函数（URL已改为/delete-bill/:id）
//       const deleteRes = await deleteBill(finalBillId); 
//       console.log('删除账单接口返回结果：', deleteRes);
      
//       if (deleteRes?.success) {
//         message.success('账单删除成功');
//         fetchData(searchText); // 刷新列表
//       } else {
//         console.error('删除账单接口返回失败：', deleteRes?.msg || '无错误信息');
//         message.error(deleteRes?.msg || '删除账单失败');
//       }
//       // 关闭弹窗并清空ID，避免重复弹窗
//       setIsDeleteModalVisible(false);
//       setCurrentDeleteBillId('');
//     } catch (err) {
//       console.error('删除账单接口调用异常（完整信息）：', {
//         status: err.response?.status,
//         responseData: err.response?.data,
//         errorMessage: err.message,
//         requestConfig: err.config,
//         requestUrl: err.config?.url
//       });
//       const errMsg = err.response?.data?.error || err.response?.data?.msg || `删除失败：${err.message}`;
//       message.error(errMsg);
//     } finally {
//       setLoading(false);
//       setCurrentDeleteBillId('');
//     }
//   };

//   // 表格列配置
//   const columns = [
//     {
//       title: '房源ID',
//       dataIndex: 'houseId',
//       key: 'houseId',
//       width: 100,
//     },
//     {
//       title: '房间ID',
//       dataIndex: 'roomId',
//       key: 'roomId',
//       width: 100,
//     },
//     {
//       title: '房源名称',
//       dataIndex: 'houseName',
//       key: 'houseName',
//       width: 150,
//     },
//     {
//       title: '房间号',
//       dataIndex: 'roomNumber',
//       key: 'roomNumber',
//       width: 120,
//     },
//     {
//       title: '账单ID',
//       dataIndex: 'billId',
//       key: 'billId',
//       width: 100,
//       render: (billId) => {
//         console.log('渲染账单ID列：', billId, '类型：', typeof billId);
//         return billId;
//       }
//     },
//     {
//       title: '租客ID',
//       dataIndex: 'tenantId',
//       key: 'tenantId',
//       width: 100,
//     },
//     {
//       title: '租客手机号',
//       dataIndex: 'tenantPhone',
//       key: 'tenantPhone',
//       width: 130,
//     },
//     {
//       title: '账单总金额',
//       dataIndex: 'totalAmount',
//       key: 'totalAmount',
//       width: 120,
//       render: (amount) => {
//         const num = Number(amount);
//         const finalAmount = isNaN(num) ? 0 : num;
//         return `¥${finalAmount.toFixed(2)}`;
//       },
//     },
//     {
//       title: '状态',
//       dataIndex: 'status',
//       key: 'status',
//       width: 100,
//       render: (status, record) => (
//         <Tag color={record.statusColor}>{status}</Tag>
//       ),
//     },
//     {
//       title: '创建时间',
//       dataIndex: 'createTime',
//       key: 'createTime',
//     },
//     {
//       title: '操作',
//       key: 'action',
//       width: 260,
//       render: (_, record) => {
//         console.log('渲染操作列，当前记录：', record);
//         return (
//           <Space size="middle">
//             <Button size="small" type="primary">查看详情</Button>
//             {record.status !== '已支付' && (
//               <Button size="small" type="success">标记支付</Button>
//             )}
//             <Button 
//               size="small" 
//               type="danger" 
//               icon={<DeleteOutlined />}
//               onClick={() => {
//                 console.log('===== 点击删除按钮 =====');
//                 console.log('当前点击的记录完整信息：', record);
//                 console.log('准备传递给删除函数的billId：', record.billId);
//                 showDeleteModal(record.billId);
//               }}
//             >
//               删除
//             </Button>
//           </Space>
//         );
//       },
//     },
//   ];

//   return (
//     <Card title="账单管理" bordered={false}>
//       <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
//         <Col flex="auto">
//           <Input
//             placeholder="搜索房源ID/房间ID/账单ID/租客信息"
//             value={searchText}
//             onChange={(e) => {
//               console.log('搜索框输入变化：', e.target.value);
//               setSearchText(e.target.value);
//             }}
//             onPressEnter={handleSearch}
//             addonAfter={
//               <Button icon={<SearchOutlined />} onClick={handleSearch}>
//                 搜索
//               </Button>
//             }
//           />
//         </Col>
//         <Col>
//           <Space>
//             <Button icon={<ReloadOutlined />} onClick={() => {
//               console.log('点击刷新按钮，重新加载所有账单');
//               fetchData();
//             }}>
//               刷新
//             </Button>
//             <Button icon={<DownloadOutlined />} type="primary">
//               导出数据
//             </Button>
//           </Space>
//         </Col>
//       </Row>

//       <Table
//         columns={columns}
//         dataSource={billData}
//         loading={loading}
//         pagination={{
//           pageSize: 10,
//           showSizeChanger: true,
//           showTotal: (total) => `共 ${total} 条账单`,
//         }}
//         scroll={{ x: 1200 }}
//         rowKey="billId" // 增加rowKey，避免表格渲染异常
//       />

//       {/* 删除确认弹窗 */}
//       <Modal
//         title="确认删除账单"
//         visible={isDeleteModalVisible}
//         onCancel={() => {
//           console.log('用户点击弹窗「取消」或遮罩，关闭删除弹窗');
//           setIsDeleteModalVisible(false);
//           setCurrentDeleteBillId('');
//         }}
//         onOk={handleDeleteConfirm}
//         width={500}
//         destroyOnClose
//         maskClosable={false}
//         okText="确认删除"
//         cancelText="取消"
//       >
//         <div style={{ lineHeight: 1.8 }}>
//           <p>确定要删除账单ID为 <strong>{currentDeleteBillId}</strong> 的账单吗？</p>
//           <p style={{ color: '#f50' }}>⚠️ 此操作不可恢复，请谨慎操作！</p>
//           {/* <p>已支付的账单不允许删除，若删除失败请检查账单状态。</p> */}
//         </div>
//       </Modal>
//     </Card>
//   );
// };

// export default BillList;

import { useEffect, useState, useRef } from 'react';
import { Tag, Space, Button, Card, message, Modal } from 'antd'; 
import { DeleteOutlined } from '@ant-design/icons';
// 🔥 恢复原来的正确导入方式（关键！）
import { getAllBills, deleteBill, batchDeleteBills, getBillDetail, markBillAsPaid } from '../../api';
import ListToolbar from '../../components/ListToolbar';
import { exportToCSV } from '../../utils/exportUtils';
import PageTitle from '../../components/PageTitle';
import ResizableTable from '../../components/ResizableTable';

const getBillId = (record) => record?.billId ?? record?.id;

const BillList = () => {
  const [billData, setBillData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const searchTextRef = useRef('');
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isBatchDeleteModalVisible, setIsBatchDeleteModalVisible] = useState(false); // 批量删除弹窗
  const [isDetailModalVisible, setIsDetailModalVisible] = useState(false);
  const [currentDeleteBillId, setCurrentDeleteBillId] = useState('');
  const [currentDetailBill, setCurrentDetailBill] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); // 存储勾选的账单ID
  const [displayColumns, setDisplayColumns] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
    total: 0,
  });

  useEffect(() => {
    searchTextRef.current = searchText;
  }, [searchText]);

  const fetchDataFromServer = async (page = 1, pageSize = null) => {
    const ps = pageSize != null ? pageSize : pagination.pageSize;
    setLoading(true);
    try {
      const res = await getAllBills(searchTextRef.current, {
        page,
        page_size: ps,
      });
      if (res?.success && Array.isArray(res.data)) {
        setBillData(res.data);
        const total = Number(res.total != null ? res.total : res.data.length);
        setPagination({
          current: Number(res.page) || page,
          pageSize: Number(res.page_size) || ps,
          total,
        });
      } else {
        setBillData([]);
        setPagination((prev) => ({ ...prev, current: 1, total: 0 }));
        message.error('账单数据格式错误');
      }
    } catch (err) {
      message.error('加载账单失败，请检查接口连接');
      setBillData([]);
      setPagination((prev) => ({ ...prev, current: 1, total: 0 }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataFromServer(1, 50);
  }, []);

  const handleSearch = () => {
    searchTextRef.current = String(searchText || '').trim();
    fetchDataFromServer(1, pagination.pageSize);
  };

  const handleReset = () => {
    setSearchText('');
    searchTextRef.current = '';
    fetchDataFromServer(1, pagination.pageSize);
  };

  // 刷新数据
  const handleRefresh = () => {
    fetchDataFromServer();
  };
  const getPaySourceText = (record) => {
    const raw = record?.pay_source ?? record?.paySource;
    const source = Number(raw);
    if (source === 1) return '租客支付入账';
    if (source === 2) return '房东/管理员标记已收款';
    return '-';
  };

  const handleViewDetail = async (record) => {
    const billId = getBillId(record);
    setCurrentDetailBill(record);
    setIsDetailModalVisible(true);
    if (billId === undefined || billId === null || billId === '') {
      return;
    }

    try {
      const res = await getBillDetail(billId);
      if (res?.success && res.data) {
        setCurrentDetailBill((prev) => ({ ...prev, ...res.data }));
      }
    } catch (err) {
      console.error('获取账单详情失败：', err);
    }
  };

  const handleMarkPaid = async (record) => {
    const billId = getBillId(record);
    if (billId === undefined || billId === null || billId === '') {
      message.error('账单ID缺失，无法标记支付');
      return;
    }
    try {
      setLoading(true);
      const res = await markBillAsPaid(billId);
      if (res?.success) {
        message.success('标记支付成功');
        await fetchDataFromServer(pagination.current, pagination.pageSize);
      } else {
        message.error(res?.msg || res?.error || '标记支付失败');
      }
    } catch (err) {
      console.error('标记支付失败：', err);
      const errMsg = err.response?.data?.error || err.response?.data?.msg || '标记支付失败，请检查后端接口';
      message.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    setLoading(true);
    let rows = billData;
    try {
      const res = await getAllBills(searchTextRef.current, { all: 1 });
      if (res?.success && Array.isArray(res.data)) {
        rows = res.data;
      }
    } catch (e) {
      message.warning('拉取导出数据失败，将导出当前页');
    } finally {
      setLoading(false);
    }
    const exportData = rows.map(bill => ({
      '账单ID': getBillId(bill),
      '房源ID': bill.houseId || '-',
      '房源名称': bill.houseName || '-',
      '房间ID': bill.roomId || '-',
      '房间号': bill.roomNumber || '-',
      '租客ID': bill.tenantId || '-',
      '租客手机号': bill.tenantPhone || '-',
      '账单金额(元)': Number(bill.totalAmount || bill.amount || 0).toFixed(2),
      '账单状态': bill.status || '未知',
      '支付来源': getPaySourceText(bill),
      '账单月份': bill.billMonth || '-',
      '创建时间': bill.createTime || '-',
    }));
    if (exportToCSV(exportData, '账单列表')) {
      message.success(`成功导出 ${exportData.length} 条数据`);
    } else {
      message.error('导出数据失败，请重试');
    }
  };

  // 打开单个删除弹窗（复用原逻辑）
  const showDeleteModal = (billId) => {
    console.log('===== 触发删除账单弹窗 =====');
    console.log('待删除账单ID：', billId, '类型：', typeof billId);
    
    if (!billId && billId !== 0) {
      console.error('账单ID为空！');
      message.warning('账单ID不能为空，请刷新页面重试');
      return;
    }
    if (isNaN(Number(billId))) {
      console.error('账单ID格式错误，不是数字：', billId);
      message.warning('账单ID必须为数字，请检查数据');
      return;
    }

    setCurrentDeleteBillId(billId);
    setIsDeleteModalVisible(true);
  };

  // 确认单个删除（复用原逻辑）
  const handleDeleteConfirm = async () => {
    const finalBillId = String(currentDeleteBillId).trim();
    if (!finalBillId) {
      console.error('当前要删除的账单ID为空！');
      message.error('删除失败：账单ID为空，请刷新页面重试');
      setIsDeleteModalVisible(false);
      return;
    }

    console.log('用户点击弹窗「确认删除」，开始调用删除接口');
    console.log('当前要删除的账单ID：', finalBillId, '类型：', typeof finalBillId);
    
    try {
      setLoading(true);
      const deleteRes = await deleteBill(finalBillId); 
      console.log('删除账单接口返回结果：', deleteRes);
      
      if (deleteRes?.success) {
        message.success('账单删除成功');
        fetchDataFromServer(pagination.current, pagination.pageSize);
      } else {
        console.error('删除账单接口返回失败：', deleteRes?.msg || '无错误信息');
        message.error(deleteRes?.msg || '删除账单失败');
      }
      setIsDeleteModalVisible(false);
      setCurrentDeleteBillId('');
    } catch (err) {
      console.error('删除账单接口调用异常（完整信息）：', {
        status: err.response?.status,
        responseData: err.response?.data,
        errorMessage: err.message,
        requestConfig: err.config,
        requestUrl: err.config?.url
      });
      const errMsg = err.response?.data?.error || err.response?.data?.msg || `删除失败：${err.message}`;
      message.error(errMsg);
    } finally {
      setLoading(false);
      setCurrentDeleteBillId('');
    }
  };

  // ===== 新增：批量删除相关逻辑 =====
  // 打开批量删除弹窗
  const showBatchDeleteModal = () => {
    if (selectedRowKeys.length === 0) {
      message.warning('请至少选择一条账单记录');
      return;
    }
    setIsBatchDeleteModalVisible(true);
  };

  // 确认批量删除
  const handleBatchDeleteConfirm = async () => {
    console.log('开始批量删除，选中的ID列表：', selectedRowKeys);
    
    try {
      setLoading(true);
      // 调用封装好的批量删除API（路径和原来的保持一致）
      const deleteRes = await batchDeleteBills(selectedRowKeys);
      console.log('批量删除接口返回结果：', deleteRes);
      
      if (deleteRes?.success) {
        message.success(deleteRes.msg || '批量删除账单成功');
        fetchDataFromServer(pagination.current, pagination.pageSize);
        setSelectedRowKeys([]);
      } else {
        console.error('批量删除接口返回失败：', deleteRes?.msg || '无错误信息');
        message.error(deleteRes?.msg || '批量删除账单失败');
      }
      setIsBatchDeleteModalVisible(false);
    } catch (err) {
      console.error('批量删除接口调用异常：', err);
      const errMsg = err.response?.data?.error || err.response?.data?.msg || `批量删除失败：${err.message}`;
      message.error(errMsg);
      setIsBatchDeleteModalVisible(false);
    } finally {
      setLoading(false);
    }
  };

  // 表格勾选配置
  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => {
      console.log('选中的账单ID：', keys);
      setSelectedRowKeys(keys);
    },
    // 可选：限制只能删除未支付的账单
    getCheckboxProps: (record) => ({
      disabled: false,
    }),
  };

  // 原始表格列配置
  const originalColumns = [
    {
      title: '房源ID',
      dataIndex: 'houseId',
      key: 'houseId',
      width: 80,
    },
    {
      title: '房间ID',
      dataIndex: 'roomId',
      key: 'roomId',
      width: 80,
    },
    {
      title: '房源名称',
      dataIndex: 'houseName',
      key: 'houseName',
      width: 130,
    },
    {
      title: '房间号',
      dataIndex: 'roomNumber',
      key: 'roomNumber',
      width: 100,
    },
    {
      title: '账单ID',
      dataIndex: 'billId',
      key: 'billId',
      width: 80,
      render: (billId) => {
        console.log('渲染账单ID列：', billId, '类型：', typeof billId);
        return billId;
      }
    },
    {
      title: '租客ID',
      dataIndex: 'tenantId',
      key: 'tenantId',
      width: 80,
    },
    {
      title: '租客手机号',
      dataIndex: 'tenantPhone',
      key: 'tenantPhone',
      width: 120,
    },
    {
      title: '账单总金额',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      width: 100,
      render: (amount) => {
        const num = Number(amount);
        const finalAmount = isNaN(num) ? 0 : num;
        return `¥${finalAmount.toFixed(2)}`;
      },
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 80,
      render: (status, record) => (
        <Tag color={record.statusColor}>{status}</Tag>
      ),
    },
    {
      title: '支付来源',
      dataIndex: 'pay_source',
      key: 'pay_source',
      width: 180,
      render: (_, record) => getPaySourceText(record),
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 160,
    },
    {
      title: '操作',
      key: 'action',
      width: 200,
      render: (_, record) => {
        console.log('渲染操作列，当前记录：', record);
        return (
          <Space size="middle">
            <Button size="small" type="primary" onClick={() => handleViewDetail(record)}>查看详情</Button>
            {record.status !== '已支付' && (
              <Button
                size="small"
                type="default"
                style={{ color: '#52c41a', borderColor: '#52c41a' }}
                onClick={() => handleMarkPaid(record)}
              >
                标记支付
              </Button>
            )}
            <Button 
              size="small" 
              type="danger" 
              icon={<DeleteOutlined />}
              onClick={() => {
                console.log('===== 点击删除按钮 =====');
                console.log('当前点击的记录完整信息：', record);
                console.log('准备传递给删除函数的billId：', getBillId(record));
                showDeleteModal(getBillId(record));
              }}
            >
              删除
            </Button>
          </Space>
        );
      },
    },
  ];

  // 从localStorage加载列设置并应用到表格（只处理隐藏）
  useEffect(() => {
    const storageKey = 'billList_columnStates';
    const saved = localStorage.getItem(storageKey);
    let columnStates = {};
    
    if (saved) {
      try {
        columnStates = JSON.parse(saved);
      } catch (e) {
        console.error('Failed to parse column states:', e);
      }
    }
    
    // 根据列状态生成实际列配置（只处理隐藏）
    const processedColumns = originalColumns.map(col => {
      const state = columnStates[col.key];
      
      if (state === 'hidden') {
        return null;
      }
      
      return col;
    }).filter(col => col !== null);
    
    setDisplayColumns(processedColumns);
  }, []);

  const handleTableChange = (nextPagination) => {
    const nextPage = nextPagination?.current || 1;
    const nextPs = nextPagination?.pageSize || pagination.pageSize;
    fetchDataFromServer(nextPage, nextPs);
  };

  // 保留原来的UI结构（只新增批量删除按钮）
  return (
    <div style={{ padding: '20px 0' }}>
      <PageTitle title="账单管理" />
      <Card bordered={false} style={{ marginTop: 0 }}>
      <ListToolbar
        searchPlaceholder="搜索房源ID/房间ID/账单ID/租客手机号/房源名称/房间号"
        searchValue={searchText}
        onSearchChange={setSearchText}
        onSearch={handleSearch}
        onReset={handleReset}
        onRefresh={handleRefresh}
        onExport={handleExport}
        showBatchDelete={true}
        selectedCount={selectedRowKeys.length}
        onBatchDelete={showBatchDeleteModal}
      />

      <ResizableTable
        columns={displayColumns.length > 0 ? displayColumns : originalColumns}
        dataSource={billData}
        loading={loading}
        storageKey="billList"
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          showTotal: (total) => `共 ${total} 条账单`,
        }}
        onChange={handleTableChange}
        scroll={{ x: 1200 }}
        rowKey={(record) => String(getBillId(record))}
        rowSelection={rowSelection} // 新增：添加勾选功能（不影响原有逻辑）
      />

      {/* 保留原来的单个删除弹窗 */}
      <Modal
        title="确认删除账单"
        open={isDeleteModalVisible}
        onCancel={() => {
          console.log('用户点击弹窗「取消」或遮罩，关闭删除弹窗');
          setIsDeleteModalVisible(false);
          setCurrentDeleteBillId('');
        }}
        onOk={handleDeleteConfirm}
        width={500}
        destroyOnClose
        maskClosable={false}
        okText="确认删除"
        cancelText="取消"
      >
        <div style={{ lineHeight: 1.8 }}>
          <p>确定要删除账单ID为 <strong>{currentDeleteBillId}</strong> 的账单吗？</p>
          <p style={{ color: '#f50' }}>⚠️ 此操作不可恢复，请谨慎操作！</p>
        </div>
      </Modal>

      {/* 新增：批量删除确认弹窗 */}
      <Modal
        title="确认批量删除账单"
        open={isBatchDeleteModalVisible}
        onCancel={() => setIsBatchDeleteModalVisible(false)}
        onOk={handleBatchDeleteConfirm}
        width={500}
        destroyOnClose
        maskClosable={false}
        okText="确认删除"
        cancelText="取消"
      >
        <div style={{ lineHeight: 1.8 }}>
          <p>确定要删除选中的 <strong>{selectedRowKeys.length}</strong> 条账单吗？</p>
          <p style={{ color: '#f50' }}>⚠️ 此操作不可恢复，请谨慎操作！</p>
          <p>选中的账单ID：{selectedRowKeys.join(', ')}</p>
        </div>
      </Modal>

      <Modal
        title="账单详情"
        open={isDetailModalVisible}
        onCancel={() => {
          setIsDetailModalVisible(false);
          setCurrentDetailBill(null);
        }}
        footer={[
          <Button
            key="close"
            onClick={() => {
              setIsDetailModalVisible(false);
              setCurrentDetailBill(null);
            }}
          >
            关闭
          </Button>,
        ]}
        width={700}
        destroyOnClose
      >
        {currentDetailBill && (
          <div style={{ lineHeight: 2 }}>
            <p><strong>账单ID：</strong>{getBillId(currentDetailBill) ?? '-'}</p>
            <p><strong>房源ID：</strong>{currentDetailBill.houseId ?? '-'}</p>
            <p><strong>房源名称：</strong>{currentDetailBill.houseName || '-'}</p>
            <p><strong>房间ID：</strong>{currentDetailBill.roomId ?? '-'}</p>
            <p><strong>房间号：</strong>{currentDetailBill.roomNumber || '-'}</p>
            <p><strong>租客ID：</strong>{currentDetailBill.tenantId ?? '-'}</p>
            <p><strong>租客手机号：</strong>{currentDetailBill.tenantPhone || '-'}</p>
            <p><strong>账单总金额：</strong>¥{Number(currentDetailBill.totalAmount || 0).toFixed(2)}</p>
            <p><strong>状态：</strong>{currentDetailBill.status || '-'}</p>
            <p><strong>支付来源：</strong>{getPaySourceText(currentDetailBill)}</p>
            <p><strong>账单月份：</strong>{currentDetailBill.billMonth || '-'}</p>
            <p><strong>创建时间：</strong>{currentDetailBill.createTime || '-'}</p>
          </div>
        )}
      </Modal>
      </Card>
    </div>
  );
};

export default BillList;